(() => {
  if (customElements.get('eil-product-tabs')) return;
  customElements.define('eil-product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panels = [...this.querySelectorAll('[data-eil-panel]')];
      this.nav = this.querySelector('.eil-ptabs__nav');
      if (!this.nav || !this.panels.length) return;
      this.media = window.matchMedia('(min-width: 768px)');
      this.selected = 0;
      this.nav.replaceChildren();
      this.buttons = this.panels.map((panel, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'eil-ptabs__tab';
        button.id = `${panel.id}-tab`;
        button.textContent = panel.querySelector('[data-eil-label]').textContent;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', panel.id);
        button.addEventListener('click', () => this.select(index), options);
        button.addEventListener('keydown', event => {
          const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.panels.length - 1;
          if (event.key === 'ArrowLeft') next = (index + this.panels.length - 1) % this.panels.length;
          if (event.key === 'ArrowRight') next = (index + 1) % this.panels.length;
          this.select(next);
          this.buttons[next].focus();
        }, options);
        panel.addEventListener('toggle', event => {
          if (event.target === panel && !panel.open) this.pause(panel);
        }, options);
        this.nav.append(button);
        return button;
      });
      this.media.addEventListener('change', () => this.setMode(), options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
        if (index < 0) return;
        if (this.media.matches) this.select(index);
        else this.panels[index].open = true;
      }, options);
      this.setMode();
    }

    pause(panel) {
      panel.querySelectorAll('video').forEach(video => video.pause());
      panel.querySelectorAll('.eil-ptabs__youtube').forEach(frame => {
        frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), 'https://www.youtube-nocookie.com');
      });
    }

    setMode() {
      const desktop = this.media.matches;
      this.classList.toggle('eil-ptabs__component--desktop', desktop);
      this.nav.hidden = !desktop;
      this.panels.forEach((panel, index) => {
        if (desktop) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.buttons[index].id);
          panel.tabIndex = 0;
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
          panel.removeAttribute('tabindex');
          panel.hidden = false;
          panel.open = false;
          this.pause(panel);
        }
      });
      if (desktop) this.select(this.selected);
    }

    select(index) {
      this.selected = index;
      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.hidden = !active;
        panel.open = active;
        this.buttons[i].setAttribute('aria-selected', String(active));
        this.buttons[i].tabIndex = active ? 0 : -1;
        if (!active) this.pause(panel);
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
})();
